import * as Yup from "yup";
import { toast } from "react-toastify";
import FormDefault from "../../components/Forms/FormDefault";
import { requestAuth } from "../../components/services/RequestService";


export const FormAddSubDataDynamic = ({ data, onClose, reload, addTitle = null, allowEmpty = false, formFields = [], refFileIndex = 'url', initVals = {}, urlApi, dropdownListLabel, reloadOptions }) => {
  const initialValuesDets = Object.keys(data).reduce((acc, key) => {
    if (key.startsWith("det_")) {
      acc[key] = data[key] ?? null;
    }
    return acc;
  }, {});

  async function uploadFile(values) {
    if (typeof values[refFileIndex] === "string") {
      onSubmit(values);
    } else if (values[refFileIndex]) {
      let formData = new FormData();
      formData.append("Name", data.label);
      formData.append("File", values[refFileIndex]);
      formData.append("originalName", values[refFileIndex].name);
      formData.append("Status", "verified");
      // formData.append("ProcedureId", field.id);

      await requestAuth("post", "/files", formData)
        .then((res) => {
          onSubmit({
            ...values,
            [refFileIndex]: res.data.url,
            [refFileIndex.replace("Ref", "")]: res.data.url
          });
        })
        .catch(() => {
          toast.error("Se produjo un error al subir el archivo");
        });
    } else {
      onSubmit(values);
    }
  }

  function editOnSubmit(values) {
    onSubmit(values);
  }

  async function onSubmit(values) {
    if (values.label.endsWith("_isNew")) {
      values.label = values.label.replace("_isNew", "")
      await handleCreateOption(values.label);
    }

    const details = {};
    Object.keys(values)
      .filter((key) => key.startsWith("det_"))
      .forEach((key) => {
        details[key] = values[key];
      });

    const payload = {
      ...values,
      details: JSON.stringify(details),
    };

    await requestAuth(
      data.id ? "put" : "post",
      urlApi,
      payload
    )
      .then(() => {
        reload();
        onClose();
        toast.success("Registro exitoso");
      })
      .catch(() => {
        toast.error("Se produjo un error al guardar");
      });
  }

  async function handleCreateOption(value) {
    await requestAuth("post", "/dropdown/option", {
      Name: value,
      DropdownListLabel: dropdownListLabel,
    })
      .then(() => {
        reloadOptions && reloadOptions();
        toast.success("Opción creada exitosamente");
      })
      .catch(() => {
        toast.error("Se produjo un error al crear la opción");
      });

  }


  return (
    <div className="mb-6 xl:w-[600px]">
      <FormDefault
        tittle={addTitle ? addTitle.replace("_isNew", "") : `Adicionar archivo`}
        fields={
          formFields
        }
        initialValues={{
          // tariffItem: field.fieldId === 233 ? data.name || "401" : null,
          url: data.url ?? null,
          ...initialValuesDets,
          ...initVals,
        }}
        validationSchema={Yup.object().shape(
        )}
        onSubmit={(values) =>
          !values[refFileIndex] || (typeof values[refFileIndex] === "string" && values.tariffItem !== "0")
            ? editOnSubmit(values)
            : uploadFile(values)
        }
        buttonName="Registrar"
      />
    </div>
  );
};


export default FormAddSubDataDynamic;
